import React from 'react';

import InnerLink from '../InnerLink';

export default function Boolean({ value, link, row }) {
  const formattedValue = value === true ? 'Yes' : 'No';

  if (link && link(row)) {
    return <InnerLink to={link(row)}>{formattedValue}</InnerLink>;
  }

  return <div>{formattedValue}</div>;
}
